import React from 'react'

export default function CommonSlavicSounds() {
  return (
    <table>
      <tbody>
        <tr>
          <th rowSpan={2}>
            Proto-Slavic
          </th>
          <th rowSpan={2}>OCS</th>
          <th rowSpan={2}>Slavic</th>
          <th colSpan={2}> Interslavic </th>
          <th colSpan={2}>Examples</th>
        </tr>
        <tr>
          <th> Etymological alphabet </th>
          <th> Standard alphabet </th>
          <th> Etymological alphabet </th>
          <th> Standard alphabet </th>
        </tr>
        <tr>
          <td>
            <b>y</b>
          </td>
          <td>
            <b>ꙑ, ъи</b>
          </td>
          <td>
            ESl./WSl. <b>y</b>, SSl. <b>i</b>
          </td>
          <td>
            <b>y</b>
          </td>
          <td>
            <b>y</b>
          </td>
          <td>
            b<b>y</b>ti, dobr<b>y</b>
          </td>
          <td>
            b<b>y</b>ti, dobr<b>y</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>ě</b>
          </td>
          <td>
            <b>ѣ</b>
          </td>
          <td>
            RU/BE <b>'e</b>, UK <b>i</b>, PL <b>ie/ia</b>, CZ <b>ě/e/a</b>, SK
            <b>ie/e/a</b>, SL/SR/MK <b>e</b>, HR <b>(i)je</b>, BG <b>e/ja</b>
          </td>
          <td>
            <b>ě</b>
          </td>
          <td>
            <b>ě</b>
          </td>
          <td>
            sv<b>ě</b>t, r<b>ě</b>ka
          </td>
          <td>
            sv<b>ě</b>t, r<b>ě</b>ka
          </td>
        </tr>
        <tr>
          <td>
            <b>ę</b>
          </td>
          <td>
            <b>ѧ</b>
          </td>
          <td>
            ESl. <b>ja</b>, PL <b>ią/ię</b>, CZ <b>a/ě</b>, SK <b>ä/a/ia</b>, SSl.
            <b>e</b>
          </td>
          <td>
            <b>ę</b>
          </td>
          <td>
            <b>e</b>
          </td>
          <td>
            j<b>ę</b>zyk, sv<b>ę</b>ty
          </td>
          <td>
            j<b>e</b>zyk, sv<b>e</b>ty
          </td>
        </tr>
        <tr>
          <td>
            <b>ǫ</b>
          </td>
          <td>
            <b>ѫ</b>
          </td>
          <td>
            PL <b>ą/ę</b>, CZ <b>u/ou/i</b>, SL <b>o</b>, MK <b>a</b>, BG <b>ă/a</b>
            , otherwise <b>u</b>
          </td>
          <td>
            <b>ų</b>
          </td>
          <td>
            <b>u</b>
          </td>
          <td>
            p<b>ų</b>t́, r<b>ų</b>ka
          </td>
          <td>
            p<b>u</b>t, r<b>u</b>ka
          </td>
        </tr>
        <tr>
          <td>
            initial <b>ǫ-</b>
          </td>
          <td>
            <b>ѫ-</b>
          </td>
          <td>
            RU/CZ/SK <b>u-</b>, PL <b>wą-</b>, SB <b>wu-</b>; other languages are
            less consistent
          </td>
          <td>
            <b>vų-</b>
          </td>
          <td>
            <b>vu-</b>
          </td>
          <td>
            <b>vų</b>troby, pa<b>vų</b>k
          </td>
          <td>
            <b>vu</b>troby, pa<b>vu</b>k
          </td>
        </tr>
        <tr>
          <td>
            strong <b>ь</b>
          </td>
          <td>
            <b>ь</b>
          </td>
          <td>
            BCMS <b>a</b>, otherwise <b>e</b>
          </td>
          <td>
            <b>ė</b>
          </td>
          <td>
            <b>e</b>
          </td>
          <td>
            ot<b>ė</b>c, p<b>ė</b>s
          </td>
          <td>
            ot<b>e</b>c, p<b>e</b>s
          </td>
        </tr>
        <tr>
          <td>
            strong <b>ъ</b>
          </td>
          <td>
            <b>ъ</b>
          </td>
          <td>
            ESl./SK/MK <b>o</b>, PL/CZ/SL <b>e</b>, BCMS <b>a</b>, BG <b>ă</b>
          </td>
          <td>
            <b>ȯ</b>
          </td>
          <td>
            <b>o</b>
          </td>
          <td>
            s<b>ȯ</b>n, pěs<b>ȯ</b>k
          </td>
          <td>
            s<b>o</b>n, pěs<b>o</b>k
          </td>
        </tr>
        <tr>
          <td>
            (C)<b>or</b>C<br />
            (C)<b>ol</b>C
          </td>
          <td>
            <b>
              ра
              <br />
              ла
            </b>
          </td>
          <td>
            ESl. <b>(o)ro/(o)lo</b>, PL <b>ro/ło</b>, SSl./CZ/SK <b>ra/la</b>
          </td>
          <td>
            <b>
              rå
              <br />
              lå
            </b>
          </td>
          <td>
            <b>
              ra
              <br />
              la
            </b>
          </td>
          <td>
            g<b>rå</b>d, k<b>rå</b>va
            <br />g<b>lå</b>va, m<b>lå</b>dy
          </td>
          <td>
            g<b>ra</b>d, k<b>ra</b>va
            <br />g<b>la</b>va, m<b>la</b>dy
          </td>
        </tr>
        <tr>
          <td>
            (C)<b>er</b>C<br />
            (C)<b>el</b>C
          </td>
          <td>
            <b>
              рѣ
              <br />
              лѣ
            </b>
          </td>
          <td>
            ESl. <b>(e)re/(o)lo</b>, PL <b>rze/le</b>, CZ <b>ře/lě</b>, SK
            <b>re/lie</b>, SL/SR/MK <b>re/le</b>, HR <b>rije/lije</b>, BG
            <b>rja/lja</b>
          </td>
          <td>
            <b>
              rě
              <br />
              lě
            </b>
          </td>
          <td>
            <b>
              rě
              <br />
              lě
            </b>
          </td>
          <td>
            b<b>rě</b>g, p<b>rě</b>d<br />m
            <b>lě</b>ko
          </td>
          <td>
            b<b>rě</b>g, p<b>rě</b>d<br />m
            <b>lě</b>ko
          </td>
        </tr>
        <tr>
          <td>
            C<b>ъrC</b>
          </td>
          <td>
            <b>ръ</b>
          </td>
          <td>
            ESl. <b>or</b>, PL <b>ar</b>, BG <b>ъr</b>, otherwise <b>r</b>
          </td>
          <td>
            <b>r</b>
          </td>
          <td>
            <b>r</b>
          </td>
          <td>
            t<b>r</b>g, k<b>r</b>čma
          </td>
          <td>
            t<b>r</b>g, k<b>r</b>čma
          </td>
        </tr>
        <tr>
          <td>
            C<b>ьr</b>C
          </td>
          <td>
            <b>рь</b>
          </td>
          <td>
            ESl. <b>er</b>, PL <b>ar/ierz</b>, BG <b>ъr</b>, otherwise <b>r</b>
          </td>
          <td>
            <b>ŕ</b>
          </td>
          <td>
            <b>r</b>
          </td>
          <td>
            d<b>ŕ</b>žati, sm<b>ŕ</b>t́
          </td>
          <td>
            d<b>r</b>žati, sm<b>r</b>t
          </td>
        </tr>
        <tr>
          <td>
            C<b>ъl</b>C
          </td>
          <td>
            <b>lъ</b>
          </td>
          <td>
            RU/SL/MK <b>ol</b>, BE/UK <b>ou</b>, PL <b>oł/łu/eł</b>, CZ/SK
            <b>l/lu</b>, BCMS <b>u</b>, BG <b>ъl</b>
          </td>
          <td>
            <b>ȯl</b>
          </td>
          <td>
            <b>ol</b>
          </td>
          <td>
            d<b>ȯl</b>g, k<b>ȯl</b>basa
          </td>
          <td>
            d<b>ol</b>g, k<b>ol</b>basa
          </td>
        </tr>
        <tr>
          <td>
            C<b>ьl</b>C
          </td>
          <td>
            <b>ль</b>
          </td>
          <td>
            RU/SL/MK <b>ol</b>, BE/UK <b>ou</b>, PL <b>oł/łu/eł/il</b>, CZ/SK
            <b>l/lu</b>, BCMS <b>u</b>, BG <b>ъl</b>
          </td>
          <td>
            <b>ȯl</b>
          </td>
          <td>
            <b>ol</b>
          </td>
          <td>
            t<b>ȯl</b>sty, v<b>ȯl</b>k
          </td>
          <td>
            t<b>ol</b>sty, v<b>ol</b>k
          </td>
        </tr>
        <tr>
          <td>
            <b>
              pj, bj,
              <br />
              mj, vj
            </b>
          </td>
          <td>
            <b>пль, бль...</b>
          </td>
          <td>
            ESl./SSl. <b>plj, blj</b>..., WSl. <b>p, b</b>...
          </td>
          <td>
            <b>pj, bj, mj, vj</b>
          </td>
          <td>
            <b>pj, bj, mj, vj</b>
          </td>
          <td>
            ku<b>pj</b>ų, ze<b>mj</b>a
          </td>
          <td>
            ku<b>pj</b>u, ze<b>mj</b>a
          </td>
        </tr>
        <tr>
          <td>
            <b>
              lь, lj
              <br />
              nь, nj
            </b>
          </td>
          <td>
            <b>
              ль
              <br />
              нь
            </b>
          </td>
          <td>
            ESl./PL <b>ľ/ń</b>, otherwise <b>ľ/l</b>, <b>ń/n</b>
          </td>
          <td>
            <b>
              lj
              <br />
              nj
            </b>
          </td>
          <td>
            <b>
              lj
              <br />
              nj
            </b>
          </td>
          <td>
            <b>lj</b>ubiti, hva<b>lj</b>eńje
            <br />
            de<b>nj</b>, hrå<b>nj</b>eńje
          </td>
          <td>
            <b>lj</b>ubiti, hva<b>lj</b>enje
            <br />
            de<b>nj</b>, hra<b>nj</b>enje
          </td>
        </tr>
        <tr>
          <td>
            <b>rь, rj</b>
          </td>
          <td>
            <b>рь</b>
          </td>
          <td>
            RU/PL/CZ/SL <b>ŕ</b>, otherwise <b>r</b>
          </td>
          <td>
            <b>ŕ, rj</b>
          </td>
          <td>
            <b>r, rj</b>
          </td>
          <td>
            ca<b>ŕ</b>, tvo<b>rj</b>eńje
          </td>
          <td>
            ca<b>r</b>, tvo<b>rj</b>enje
          </td>
        </tr>
        <tr>
          <td>
            <b>
              tь
              <br />
              dь
            </b>
          </td>
          <td>
            <b>
              ть
              <br />
              дь
            </b>
          </td>
          <td>
            RU/UK/SK <b>t́/d́</b>, PL/BE <b>ć/dź</b>, CZ/SSl. <b>t/d</b>
          </td>
          <td>
            <b>
              t́
              <br />
              d́
            </b>
          </td>
          <td>
            <b>
              t<br />d
            </b>
          </td>
          <td>
            kos<b>t́</b>
            <br />
            dóž<b>d́</b>
          </td>
          <td>
            kos<b>t</b>
            <br />
            dož<b>d</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>
              sь
              <br />
              zь
            </b>
          </td>
          <td>
            <b>
              сь
              <br />
              зь
            </b>
          </td>
          <td>
            ESl./PL <b>ś/ź</b>, otherwise <b>s/z</b>
          </td>
          <td>
            <b>
              ś<br />ź
            </b>
          </td>
          <td>
            <b>
              s<br />z
            </b>
          </td>
          <td>
            lo<b>ś</b>
            <br />
            knę<b>ź</b>
          </td>
          <td>
            lo<b>s</b>
            <br />
            kne<b>z</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>
              sj
              <br />
              zj
            </b>
          </td>
          <td>
            <b>
              ш<br />ж
            </b>
          </td>
          <td>
            everywhere <b>š/ž</b>
          </td>
          <td>
            <b>
              š<br />ž
            </b>
          </td>
          <td>
            <b>
              š<br />ž
            </b>
          </td>
          <td>
            pro<b>š</b>ų<br />
            tę<b>ž</b>eńje
          </td>
          <td>
            pro<b>š</b>u<br />
            te<b>ž</b>enje
          </td>
        </tr>
        <tr>
          <td>
            <b>
              tj, kt́
              <br />
              dj, gd́
            </b>
          </td>
          <td>
            <b>
              щ<br />
              жд
            </b>
          </td>
          <td>
            ESl./SL <b>č</b>, WSl. <b>c</b>, BCMS <b>ć</b>, MK <b>kj</b>, BG
            <b>št</b>
            <br />
            ESl. <b>ž</b>, PL <b>dz</b>, CZ/SK <b>z</b>, SL <b>d/j</b>, BCMS
            <b>đ</b>, MK <b>gj</b>, BG <b>žd</b>
          </td>
          <td>
            <b>
              ć<br />đ
            </b>
          </td>
          <td>
            <b>
              č<br />
              dž
            </b>
          </td>
          <td>
            svě<b>ć</b>a, no<b>ć</b>
            <br />
            me<b>đ</b>u
          </td>
          <td>
            svě<b>č</b>a, no<b>č</b>
            <br />
            me<b>dž</b>u
          </td>
        </tr>
        <tr>
          <td>
            <b>šč</b>
          </td>
          <td>
            <b>щ</b>
          </td>
          <td>
            CZ/SK/SSl. <b>št</b>, otherwise <b>šč</b>
          </td>
          <td>
            <b>šč</b>
          </td>
          <td>
            <b>šč</b>
          </td>
          <td>
            <b>šč</b>etka
          </td>
          <td>
            <b>šč</b>etka
          </td>
        </tr>
        <tr>
          <td>
            <b>tl, dl</b>
          </td>
          <td>
            <b>л</b>
          </td>
          <td>
            ESl./SSl. <b>l</b>, WSl. <b>tl/dl</b>
          </td>
          <td>
            <b>l</b>
          </td>
          <td>
            <b>l</b>
          </td>
          <td>
            mo<b>l</b>iti, gr<b>l</b>o
          </td>
          <td>
            mo<b>l</b>iti, gr<b>l</b>o
          </td>
        </tr>
        <tr>
          <td>
            <b>g</b>
          </td>
          <td>
            <b>г</b>
          </td>
          <td>
            UK/BY/CZ/SK <b>h</b>, otherwise <b>g</b>
          </td>
          <td>
            <b>g</b>
          </td>
          <td>
            <b>g</b>
          </td>
          <td>
            <b>g</b>låva, je<b>g</b>o
          </td>
          <td>
            <b>g</b>lava, je<b>g</b>o
          </td>
        </tr>
        <tr>
          <td>
            <b>
              lьje, nьje
              <br />
              tьje, dьje
              <br />
              sьje, zьje
              <br />
              rьje
            </b>
          </td>
          <td>
            <b>
              льѥ,&nbsp;ньѥ
              <br />
              тьѥ, дьѥ
              <br />
              сьѥ, зьѥ
              <br />
              рьѥ
            </b>
          </td>
          <td>
            RU <b>lije/nije</b>, UK <b>llja/nnja</b>, PL <b>le/nie</b>, CZ
            <b>lí/ní</b>, SK <b>lie/nie</b>, SL/SH/MK <b>lje/nje</b>, BG
            <b>l(i)e/n(i)e</b>
          </td>
          <td>
            <b>
              ĺje, ńje
              <br />
              ŕje
              <br />
              t́je, d́je
              <br />
              śje, źje
            </b>
          </td>
          <td>
            <b>
              lje, nje
              <br />
              rje
              <br />
              tje, dje
              <br />
              sje, zje
            </b>
          </td>
          <td>
            usi<b>ĺj</b>e, děla<b>ńj</b>e, primo
            <b>ŕj</b>e, ži<b>t́j</b>e, orų
            <b>d́j</b>e, podlě<b>śj</b>e
          </td>
          <td>
            usi<b>lj</b>e, děla<b>nj</b>e, primo
            <b>rj</b>e, ži<b>tj</b>e, oru
            <b>dj</b>e, podlě<b>sj</b>e
          </td>
        </tr>
      </tbody>
    </table>
  )
}
